<template>
  <Card class="p-5" id="youtube-card">
    <div class="row">
      <div class="col-md-6">
        <div class="d-flex justify-content-center align-items-center h-100">
          <iframe
            width="auto"
            height="auto"
            src="https://www.youtube.com/embed/RZflvcy-Hs8"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="col-md-6">
        <div class="mb-3" v-html="$t('dashboard.youtubeInfoLine1')"></div>
        <div class="mb-3" v-html="$t('dashboard.youtubeInfoLine2')"></div>
        <a
          :href="`${youtubeUrl}`"
          target="_blank"
          class="btn btn-danger rounded-sm"
          ><i class="fab fa-youtube"></i>
          {{ $t('dashboard.followOnYoutube') }}</a
        >
      </div>
    </div>
  </Card>
</template>

<script>
export default {
  name: 'Dashboard.Youtube',
  computed: {
    youtubeUrl() {
      return process.env.VUE_APP_YOUTUBE_URL &&
        process.env.VUE_APP_YOUTUBE_URL != ''
        ? process.env.VUE_APP_YOUTUBE_URL
        : ''
    },
  },
}
</script>

<style lang="scss" scoped>
#youtube-card {
  iframe {
    width: 100%;
    height: 100%;
    min-height: 300px;
    box-shadow: rgb(100 100 111 / 20%) 0px 7px 29px 0px;
  }
}
</style>
